module.exports = __webpack_public_path__ + "mx.4be85eab5ddde9a03ffc.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mx.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mx.svg
// module chunks = styles